module.exports = __webpack_public_path__ + "images/avatars/female/5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/5.svg
// module id = FHxu
// module chunks = 154